import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  GeneralErrandDefaultDescriptionConfig,
  type GeneralErrandDefaultDescription,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
import { cn } from '@/lib/cn';
import Dot from './dot';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const GeneralErrandDefaultDescriptionItem: RelationFieldProps<GeneralErrandDefaultDescription> =
  {
    nested: getRelationFieldNames(GeneralErrandDefaultDescriptionConfig),
    renderItem: (item, isRelationField) => {
      return {
        title: item.title,
        descriptionItems: (
          <div
            className={cn(
              'flex w-full items-center',
              isRelationField && 'justify-between'
            )}
          >
            <strong>Kod:</strong> {item.code}
            {!isRelationField && <Dot />}
            {item.description ? (
              <Tooltip>
                <TooltipTrigger asChild>
                  <div className='max-w-72 truncate'>{item.description}</div>
                </TooltipTrigger>
                <TooltipContent className='max-w-80'>
                  {item.description}
                </TooltipContent>
              </Tooltip>
            ) : (
              <span>Ingen beskrivning</span>
            )}
          </div>
        ),
      };
    },
  };
